var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCscChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2781_55825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5076 7.66464C33.9272 6.90995 37.4408 8.44121 39.2758 11.486C41.1108 14.5307 40.8685 18.4272 38.6712 21.2099C36.4738 23.9926 32.7988 25.0568 29.5003 23.8656C26.2016 22.6743 23.9961 19.4866 23.9963 15.9105H16.6953C16.6896 23.0543 21.339 29.3277 28.0683 31.2556C34.7975 33.1836 41.9592 30.2941 45.5864 24.1878C49.2136 18.0816 48.4184 10.2532 43.6413 5.03906C38.8641 -0.175123 31.2745 -1.49874 25.0763 1.80138C27.3468 3.24969 29.2166 5.26822 30.5076 7.66464Z",
    fill: "#5F5FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3414 24.1845C13.9219 24.9392 10.4085 23.4081 8.57341 20.3636C6.73833 17.319 6.98038 13.4226 9.17742 10.6399C11.3744 7.85705 15.0491 6.79253 18.3478 7.98326C21.6464 9.174 23.8523 12.3613 23.8527 15.9373H31.1538C31.1594 8.79346 26.51 2.52014 19.7808 0.592192C13.0515 -1.33575 5.88982 1.55365 2.26261 7.65991C-1.36462 13.7662 -0.569415 21.5946 4.20773 26.8087C8.98488 32.0229 16.5745 33.3465 22.7727 30.0464C20.5025 28.5984 18.6327 26.5804 17.3414 24.1845Z",
    fill: "#17E5AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2781_55825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCscChain);
export default __webpack_public_path__ + "static/media/csc-chain.30fe3229709c3dc6f9d41a74735810c9.svg";
export { ForwardRef as ReactComponent };